import { useTranslation } from 'react-i18next';
import ConfirmationModal from './ConfirmationModal';

export default function ConfirmDeletionModal({ children, ...rest }) {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      buttonText={t('Confirm Delete')}
      heading={t('Please Confirm Deletion')}
      defaultLeftBtnText={t('Cancel')}
      {...rest}
    >
      {children}
    </ConfirmationModal>
  );
}
